import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import PasswordGate from './components/PasswordGate';
import Layout from './components/Layout';
import Pricing from './pages/Pricing';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import Signup from './pages/Signup';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Messaging from './pages/Messaging';
import Promotions from './pages/Promotions';
import Loyalty from './pages/Loyalty';
import Integrations from './pages/Integrations';
import GoogleReviews from './pages/GoogleReviews';
import SmartAnswers from './pages/SmartAnswers';
import TheData from './pages/TheData';
import WhyTableChat from './pages/WhyTableChat';
import MessagingPolicy from './pages/MessagingPolicy';
import NotFound from './pages/NotFound';
import './styles/global.css';

function App() {
  return (
    <PasswordGate>
    <Router>
      <Routes>
        <Route path="/" element={<Layout><WhyTableChat /></Layout>} />
        <Route path="/features/messaging" element={<Layout><Messaging /></Layout>} />
        <Route path="/features/promotions" element={<Layout><Promotions /></Layout>} />
        <Route path="/features/loyalty" element={<Layout><Loyalty /></Layout>} />
        <Route path="/features/google-reviews" element={<Layout><GoogleReviews /></Layout>} />
        <Route path="/features/smart-answers" element={<Layout><SmartAnswers /></Layout>} />
        <Route path="/features/integrations" element={<Layout><Integrations /></Layout>} />
        <Route path="/data" element={<Layout><TheData /></Layout>} />
        <Route path="/pricing" element={<Layout><Pricing /></Layout>} />
        <Route path="/faq" element={<Layout><FAQ /></Layout>} />
        <Route path="/contact" element={<Layout><Contact /></Layout>} />
        <Route path="/signup" element={<Layout><Signup /></Layout>} />
        <Route path="/privacy" element={<Layout><Privacy /></Layout>} />
        <Route path="/terms" element={<Layout><Terms /></Layout>} />
        <Route path="/messaging-policy" element={<Layout><MessagingPolicy /></Layout>} />
        
        {/* Redirects for old routes */}
        <Route path="/why-tablechat" element={<Navigate to="/" replace />} />
        <Route path="/splash" element={<Navigate to="/" replace />} />
        
        {/* Catch-all route for 404 errors */}
        <Route path="*" element={<Layout><NotFound /></Layout>} />
      </Routes>
    </Router>
    </PasswordGate>
  );
}

export default App;